import styled from 'styled-components';

export const InfiniteScroll = styled.div`
  position: relative;
`;
